/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MagnetDocumentList } from '../../models/magnet-document-list';

export interface MagnetGetDocumentList$Params {

/**
 * GUID of the magnet
 */
  magnetId: string;

/**
 * Requested document count. Value must be less than or equal to 255
 */
  count?: number;
}

export function magnetGetDocumentList(http: HttpClient, rootUrl: string, params: MagnetGetDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<MagnetDocumentList>> {
  const rb = new RequestBuilder(rootUrl, magnetGetDocumentList.PATH, 'get');
  if (params) {
    rb.path('magnetId', params.magnetId, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MagnetDocumentList>;
    })
  );
}

magnetGetDocumentList.PATH = '/magnet/{magnetId}/document/list';
